import { type FirebaseApp, initializeApp } from 'firebase/app';
import {
  type Auth,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  type UserCredential,
} from 'firebase/auth';

import { FIREBASE_CONFIG } from '../config';
import { initializeCrashlytics } from '../util/crashlytics';

// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;
let googleProvider: GoogleAuthProvider;

export function initializeFirebase() {
  if (!app) {
    app = initializeApp(FIREBASE_CONFIG);
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();

    // Инициализировать Crashlytics (Firestore)
    initializeCrashlytics(app);

    // Optional: Add scopes for additional Google API access
    // googleProvider.addScope('https://www.googleapis.com/auth/contacts.readonly');

    // Optional: Restrict to specific domain (e.g., corporate accounts only)
    // googleProvider.setCustomParameters({
    //   'hd': '01tech.com',
    // });
  }

  return { app, auth, googleProvider };
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    initializeFirebase();
  }
  return auth;
}

export function getGoogleProvider(): GoogleAuthProvider {
  if (!googleProvider) {
    initializeFirebase();
  }
  return googleProvider;
}

/**
 * Sign in with Google using popup
 * @returns UserCredential with user info and tokens
 */
export async function signInWithGoogle(): Promise<UserCredential> {
  const firebaseAuth = getFirebaseAuth();
  const provider = getGoogleProvider();

  const result = await signInWithPopup(firebaseAuth, provider);
  return result;
}

/**
 * Get Google ID Token from the current user
 * @returns ID Token string or undefined if not signed in
 */
export async function getGoogleIdToken(): Promise<string | undefined> {
  const firebaseAuth = getFirebaseAuth();
  const user = firebaseAuth.currentUser;

  if (!user) {
    return undefined;
  }

  const idToken = await user.getIdToken();
  return idToken;
}

/**
 * Get Google Access Token from credential
 * @param credential UserCredential from signInWithPopup
 * @returns Access Token string or undefined
 */
export function getGoogleAccessToken(credential: UserCredential): string | undefined {
  const googleCredential = GoogleAuthProvider.credentialFromResult(credential);
  return googleCredential?.accessToken || undefined;
}

export { app, auth, googleProvider };
